import authState from "../atom/auth"
import i18next from "i18next"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useRecoilState } from "recoil"


export const useLogout = () => {
  const [logout, setLogout] = useState(null)
  const history = useNavigate()
  const [isLogged, setIsLogged] = useRecoilState(authState)

  useEffect(() => {
    if (logout) {
      localStorage.setItem("token", "")
      localStorage.setItem("user", "")
      localStorage.setItem("permissions", "")
    
      setIsLogged(false)
      setLogout(false)
      history("/login") 
    }
  }, [logout])

  return { setLogout }
}
